import { CoreIcon } from '../core-icon';
import bankVisaSquareSVG from '../../assets/logos/bank-visa-square.svg';
import type { IconProps } from '../core-icon';

export const BankVisaSquareIcon = (props: Omit<IconProps, 'src'>) => {
  return <CoreIcon src={bankVisaSquareSVG} {...props} />;
};
